import { render, staticRenderFns } from "./AnnouncementListScreen.vue?vue&type=template&id=67c100f1&scoped=true&"
import script from "./AnnouncementListScreen.vue?vue&type=script&lang=js&"
export * from "./AnnouncementListScreen.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementListScreen.vue?vue&type=style&index=0&id=67c100f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c100f1",
  null
  
)

export default component.exports